var mixins = {
    props: {
        name: {
            type: String
        },
        rules: {
            type: Array,
            default: () => []
        },
        removeValidationPadding: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            stringRules: []
        }
    },
    watch: {
        rules: {
            handler(newRules) {
                var i = 0
                this.stringRules.splice(0) // reactively clear
                newRules.forEach(
                    function (rule) {
                        if (!this.name) {
                            throw 'name must be specified on any component with rules'
                        }
                        var type = typeof rule
                        if (type === 'string') {
                            this.stringRules.push(rule)
                        } else if (type === 'function') {
                            var rulename = `${this.name}_${i++}`
                            this.stringRules.push(rulename)
                            this.$validator.extend(rulename, {
                                getMessage: (field, params, msg) => msg,
                                validate: (value) => {
                                    return new Promise((resolve) => {
                                        var result = rule(value)
                                        var valid = result === true
                                        resolve({
                                            valid,
                                            data: valid ? null : result ? result : 'Invalid input'
                                        })
                                    })
                                }
                            })
                        } else {
                            console.error(`Invalid validation rule with type: ${type}`)
                        }
                    }.bind(this)
                )
            },
            immediate: true
        }
    },
    computed: {
        hasValidation() {
            return this.rules.any()
        },
        validationRule() {
            return this.stringRules.join('|')
        },
        hasValidationErrors() {
            return this.errors.has(this.name)
        },
        errorText() {
            return this.errors.first(this.name) || null
        },
        label_text() {
            if (this.isRequired && this.label) {
                return `${this.label} *`
            }
            return this.label
        },
        placeholder_text() {
            var text = this.$attrs.placeholder || this.labelPlaceholder
            if (text && this.isRequired) {
                return `${text} *`
            }
            return text
        },
        isRequired() {
            return this.rules.indexOf('required') != -1
        }
    }
}

export default mixins
